export const faqTranslation = {
  en: {
    FAQs: "FAQs",
    "Add FAQ": "Add FAQ",
    "Edit FAQ": "Edit FAQ",
    Delete: "Delete",
    "Search by question": "Search by question...",
    Question: "Question",
    Answer: "Answer",
    Status: "Status",
    Active: "Active",
    Inactive: "Inactive",
    "Are you sure you want to delete FAQ '{{question}}'?":
      "Are you sure you want to delete FAQ '{{question}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Created at": "Created at",
    Actions: "Actions",
    "Update FAQ": "Update FAQ",
    "Add New FAQ": "Add New FAQ",
    Cancel: "Cancel",
    "Question (EN)": "Question (EN)",
    "Question (AR)": "Question (AR)",
    "Answer (EN)": "Answer (EN)",
    "Answer (AR)": "Answer (AR)",
  },
  ar: {
    FAQs: "الأسئلة الشائعة",
    "Add FAQ": "إضافة سؤال شائع",
    "Edit FAQ": "تعديل السؤال الشائع",
    Delete: "حذف",
    "Search by question": "البحث حسب السؤال...",
    Question: "السؤال",
    Answer: "الإجابة",
    Status: "الحالة",
    Active: "نشط",
    Inactive: "غير نشط",
    "Are you sure you want to delete FAQ '{{question}}'?":
      "هل أنت متأكد أنك تريد حذف سؤال المساعدة '{{question}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Created at": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    "Update FAQ": "تحديث السؤال الشائع",
    "Add New FAQ": "إضافة سؤال شائع جديد",
    Cancel: "إلغاء",
    "Question (EN)": "السؤال (بالإنجليزية)",
    "Question (AR)": "السؤال (بالعربية)",
    "Answer (EN)": "الإجابة (بالإنجليزية)",
    "Answer (AR)": "الإجابة (بالعربية)",
  },
};
